<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Doc — Listagem e exibição
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        | ,
        strong  filtrar
        |  e
        strong  abrir
        |  um documento no menu
        strong  Doc → Documentos
        | . A emissão (botão
        code  +
        | ) e as ações do menu
        strong  Ações
        |  ficam em outros manuais.

      .toast.toast-primary
        | A listagem exige a permissão
        strong  Fiscalização → Documentos → Listar
        | . A exibição exige
        strong  Fiscalização → Documentos → Exibir
        | .

      h5.h5 1. Abrir Documentos
      ol
        li No menu lateral, clique em
          strong  Doc
          | .
        li Clique em
          strong  Documentos
          | .
      p Você chega à listagem de documentos do departamento atual.

      h5.h5 2. Listagem e filtros
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de Documentos com filtros e cards")
      p Cada documento aparece em um
        strong  card
        |  com número/ano, modelo, cadastro, situação, valor, senha web,
        |  reincidente, situação do comentário, fiscal e data de inserção.
      ol
        li Use os filtros (número, ano, situação, datas, fiscal etc.).
        li Clique no ícone de
          strong  engrenagem
          |  para habilitar campos adicionais.
        li Clique na
          strong  lupa
          |  para aplicar a busca.
        li No rodapé do card, clique em
          strong  Exibir
          |  (ícone de olho).

      h5.h5 3. Tela de exibição
      figure.manual-figure
        img(:src="imgShow" alt="Exibição de um documento")
      p No topo ficam tipo, número/ano, situação e
        strong  Visualizar impressão
        | . Abaixo: modelo, ciência, prazo, fiscal, cadastro,
        |  irregularidades, textos, valores, OS vinculadas e comentários.
      p No rodapé, use
        strong  Imprimir
        | ,
        strong  PDF
        | ,
        strong  Logs
        |  e o menu
        strong  Ações
        |  (detalhado nos manuais de ações Doc).
      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/12-doc-documentos-lista.png"),
      imgShow: require("@/assets/manuais/12a-doc-documento-show.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
